import component from './CtaButtonConstructor.vue'
export default component
